import { Categories } from "./keys"

export const CategoriesData = [
    {
        "key": `${Categories.category_1.key}`,
        "title": `${Categories.category_1.title}`,
        "imageURL": "",
        "description": [
            "Components for Medical devices are sourced from suppliers of reputed brands, which are world leaders in their field. The outcome is international quality 'Made in India'"
        ],
        "specification": [
            "Endovision HD Camera System",
            "CO2 Insufflators",
            "LED Light Source Touch Screen",
            "Fiber Optic Light Cable",
            "Suction & Irrigation Pump",
            "Automatic Tourniquet",
            "Autopsy Saw",
            "Plaster Cutter with Suction",
            "Operating Stool",
            "Loupes",
            "Portable Light and Battery Backup",
            "Vaccum Suction"
        ]
    },
    {
        "key": `${Categories.category_2.key}`,
        "title": `${Categories.category_2.title}`,
        "imageURL": "",
        "description": [
            "With the help of an Endovision camera system, a laparoscopy is a procedure carried out in the belly or pelvis using small incisions. With a few tiny abdominal incisions, the laparoscope helps in diagnostic or therapeutic surgical procedures. For both common and specialized operative techniques, <b>Indus<span className='first-color'>German</span></b> provides a full line of products. Our ergonomically created technology offers the ideal tool for every activity, ensures long service life, and gives the highest level of workplace precision."
        ],
        "specification": [
            "Laparoscopy Hand Instruments",
            "Telescopes",
            "Trocars And Accessories",
            "Instruments For Gynecology",
            "Single Puncture Laparoscope",
            "Suction And Irrigation Cannula",
            "Hemolock Clip Applicator",
            "Nathanson Retractor",
            "Needle Holder"
        ]
    },
    {
        "key": `${Categories.category_3.key}`,
        "title": `${Categories.category_3.title}`,
        "imageURL": "",
        "description": [
            "In gynaecology, hysteroscopy is both a diagnostic and an operational technique. For female patients, hysteroscopy identifies, treats, and prevents illnesses. At <b>Indus<span className='first-color'>German</span></b>, we consistently create innovative items for gynaecologists and other medical professionals to utilize in hospitals."
        ],
        "specification": [
            "Hysteroscope Telescope",
            "Hysteroscopy Sheath",
            "Flexible and Semi Rigid Forceps",
            "Hysteroscopy and Irrigation Pump",
            "Monopolar and Bipolar Cautery Electrode",
            "Resectoscope",
            "Office Hysteroscope"
        ]
    },
    {
        "key": `${Categories.category_4.key}`,
        "title": `${Categories.category_4.title}`,
        "imageURL": "",
        "description": [
            "For the endoscopic treatment of urological problems, we have been creating cutting-edge devices. At <b>Indus<span className='first-color'>German</span></b>, we provide a full line of products for cystoscopy, including resectoscopes."
        ],
        "specification": [
            "Cystoscopy Resectoscopes Telescopes",
            "Cystoscopy Sheath",
            "Resectoscopy Sheath",
            "Working Elements",
            "Visual Obturator",
            "Urethrotome Sheath",
            "Nephroscope",
            "Ureterorenoscope",
            "Laser Resectoscope Set",
            "Pneumatic Lithotripter",
            "Stone Punch Set"
        ]
    },
    {
        "key": `${Categories.category_5.key}`,
        "title": `${Categories.category_5.title}`,
        "imageURL": "",
        "description": [
            "At <b>Indus<span className='first-color'>German</span></b>, we have a facility where we can offer various tools and equipment for surgical and diagnostic ear, nose, and throat procedures.",
            "Different kind of ENT surgery sets like:"
        ],
        "specification": [
            "FESS set",
            "Tympamoplasty",
            "Stapedectomy",
            "Septoplasty",
            "Rhinoplasty",
            "Bronchoscopy",
            "Tonsillectomy",
            "Esophagoscopy",
            "Micro Laryngoscopy"
        ]
    },
    {
        "key": `${Categories.category_6.key}`,
        "title": `${Categories.category_6.title}`,
        "imageURL": `/assets/images/${Categories.category_6.key}.jpg`,
        "description": [
            "A minimally invasive surgical procedure (both diagnostic and therapeutic) is called an arthroscopy. Treatment for joints such as knees, shoulders, hips, elbows, and the upper ankle is included in orthopaedic surgeries. Our facility at <b>Indus<span className='first-color'>German</span></b> has tools and equipment for arthroscopy, open joint surgery, orthopaedics, and sports medicine."
        ],
        "specification": [
            "Arthroscope",
            "Arthrosopy Pump",
            "Arthroscopy Sheath",
            "Hook Probe",
            "Arthroscopy Punch",
            "Arthroscopy Grasper",
            "Automatic Tourniquet Single Dual"
        ]
    },
    {
        "key": `${Categories.category_7.key}`,
        "title": `${Categories.category_7.title}`,
        "imageURL": `/assets/images/${Categories.category_7.key}.jpg`,
        "description": [
            "The abdominal cavity and its contents, including the oesophagus, stomach, small and large intestines, liver, pancreas, gallbladder, appendix, bile ducts, as well as the thyroid gland, are the focus of general surgery.",
            "The surgical field includes oncological surgery, reconstructive surgery, and organ transplantation, as well as the prevention, detection, conservative and surgical treatment, aftercare, and rehabilitation of surgical conditions, injuries, and complications resulting from injuries. It also includes innate and acquired changes in shape and malformations of vessels, internal organs, including the heart, supporting and movement organs, and oncological surgery. A subset of surgery known as general surgery includes visceral and vascular surgery as well as the fundamentals of surgery (basic surgery).",
            "We have a facility here at <b>Indus<span className='first-color'>German</span></b> where we can provide instruments for both diagnostic and surgical procedures."
        ],
        "specification": [
            "Forceps",
            "Scissors",
            "Needle Holders",
            "Suction Tubes",
            "Retractors (Hand/ Self/ Table)",
            "Elevator / Probes / Curettes",
            "Clamps",
            "All Sets (Major/ Minor/ Hystectomy / Laparoscopy / D & C etc.)"
        ]
    },
    {
        "key": `${Categories.category_8.key}`,
        "title": `${Categories.category_8.title}`,
        "imageURL": "",
        "description": [
            "Orthopaedics encompasses medical conditions that are aimed at treating or preventing deformities, illnesses, or injuries to the skeleton and its supporting structures (such as the bones, joints, muscles, and tendons). For orthopaedic surgery, <b>Indus<span className='first-color'>German</span></b> provides a broad selection of goods."
        ],
        "specification": [
            "Bone Holding Forceps",
            "Retractors",
            "Bone Nibbler & Cutters",
            "Bone Punch",
            "Self-Retaining Retractors",
            "Osteotomies/Chisels/Gouges",
            "Drill & Reamers",
            "Pin/ Wire & Rod Cutters",
            "Elevators And Aerates",
            "Hammers",
            "Orthopedic Instrument Sets"
        ]
    },
    {
        "key": `${Categories.category_9.key}`,
        "title": `${Categories.category_9.title}`,
        "imageURL": `/assets/images/${Categories.category_9.key}.jpg`,
        "description": [
            "In neurosurgery, conditions affecting the central and peripheral nerve systems are identified and surgically treated. A modern and user-friendly set of tools for neuro-surgical treatments on the brain, spine, spinal marrow, and peripheral nerves has been created by <b>Indus<span className='first-color'>German</span></b>. For many neurological surgeries, our Instruments and Retractor system provides the ideal platform"
        ],
        "specification": [
            "Suction and Irrigation Cannulas",
            "Gigli Wire",
            "Hudson Brace",
            "Rongeurs /Punches",
            "Retractors",
            "Spatulas",
            "Electrodes",
            "Bone Cutter & Nibblers",
            "Forceps & Scissors"
        ]
    },
    {
        "key": `${Categories.category_10.key}`,
        "title": `${Categories.category_10.title}`,
        "imageURL": "",
        "description": [
            "One of the most prevalent reasons for neurosurgical intervention is disorders of the spine. At <b>Indus<span className='first-color'>German</span></b>, we provide a full line of equipment for invasive surgical treatments to treat disc and spine issues."
        ],
        "specification": [
            "Laminectomy Punches",
            "Disc Nibbler",
            "Bone Cutter",
            "Osteotomies / Chisels /Gouges",
            "Mallets",
            "Bone Graft Impactor",
            "Elevators & Dissectors",
            "Retractors",
            "Curettes /Hook / Probe",
            "Bayonet Instruments"
        ]
    },
    {
        "key": `${Categories.category_11.key}`,
        "title": `${Categories.category_11.title}`,
        "imageURL": "",
        "description": [
            "A surgical speciality called plastic surgery focuses on repairing facial and physical deformities brought on by disease, burns, trauma, and birth problems. For practices, clinics, and operation teams around the world, <b>Indus<span className='first-color'>German</span></b> provides a flexible choice of solutions using the most recent technologies."
        ],
        "specification": [
            "Micro Needle Holders and Scissors",
            "Cannulas Mircro Surgery",
            "Retractors Mircro Surgery",
            "Micro Forceps",
            "Osteotome Chisel and Gouge",
            "Mallet Gouge"
        ]
    },
    {
        "key": `${Categories.category_12.key}`,
        "title": `${Categories.category_12.title}`,
        "imageURL": `/assets/images/${Categories.category_12.key}.jpg`,
        "description": [],
        "specification": [
            "Extraction Set",
            "Maxillofacial Instruments Set",
            "General Dentistry",
            "Cranio-Mayillofacial Sets"
        ]
    },
    {
        "key": `${Categories.category_13.key}`,
        "title": `${Categories.category_13.title}`,
        "imageURL": ``,
        "description": [],
        "specification": []
    },
    {
        "key": `${Categories.category_14.key}`,
        "title": `${Categories.category_14.title}`,
        "imageURL": ``,
        "description": [],
        "specification": []
    },
    {
        "key": `${Categories.category_15.key}`,
        "title": `${Categories.category_15.title}`,
        "imageURL": ``,
        "description": [],
        "specification": []
    },
    {
        "key": `${Categories.category_16.key}`,
        "title": `${Categories.category_16.title}`,
        "imageURL": ``,
        "description": [],
        "specification": [
            "Fine surgery instruments",
            "Open surgery instruments",
            "General surgery instruments"
        ]
    }
]